import React from 'react';
import { IStateAwareArea } from 'types/map';
import { getIconStyle } from 'components/Map/AreaMarker/styles';

export interface Props {
  area: IStateAwareArea,
  selected?: boolean,
}

export default function GateIcon({ selected = false }: Props) {
  return (
    <img
      alt=""
      src={'/img/gate-icon.png'}
      style={getIconStyle(selected)}
    />
  );
}